import { GridscaleObjects } from '../GridscaleObjects.js';
class MarketplacePlan extends GridscaleObjects {
  constructor(_api) {
    super(_api, '/marketplace/v1/plans');
  }
}
export { MarketplacePlan };
